// The date and time formats the app offers (Settings > Date & time), and which one a locale uses.

// Available date formats
export const DATE_FORMATS = [
  { value: 'MM/dd/yyyy', label: 'MM/DD/YYYY (12/31/2024)', example: '12/31/2024' },
  { value: 'dd/MM/yyyy', label: 'DD/MM/YYYY (31/12/2024)', example: '31/12/2024' },
  { value: 'yyyy-MM-dd', label: 'YYYY-MM-DD (2024-12-31)', example: '2024-12-31' },
  { value: 'dd.MM.yyyy', label: 'DD.MM.YYYY (31.12.2024)', example: '31.12.2024' },
  { value: 'MMM d, yyyy', label: 'MMM D, YYYY (Dec 31, 2024)', example: 'Dec 31, 2024' },
  { value: 'd MMM yyyy', label: 'D MMM YYYY (31 Dec 2024)', example: '31 Dec 2024' },
];

// Available time formats
export const TIME_FORMATS = [
  { value: '12h', label: '12-hour (2:30 PM)', example: '2:30 PM' },
  { value: '24h', label: '24-hour (14:30)', example: '14:30' },
];

/** The date and time format (DATE_FORMATS / TIME_FORMATS values) people of this locale
 * ("sk", "en-GB") expect: 31.12.2024 and 14:30 in Slovakia, Dec 31, 2024 and 2:30 PM in the US. */
export const formatsForLocale = (locale) => {
  try {
    const hourCycle = new Intl.DateTimeFormat(locale, { hour: 'numeric' }).resolvedOptions().hourCycle;
    const parts = new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit', year: 'numeric' })
      .formatToParts(new Date(2024, 11, 31));
    const order = parts.filter((p) => ['day', 'month', 'year'].includes(p.type)).map((p) => p.type[0]).join('');
    const dot = parts.some((p) => p.type === 'literal' && p.value.includes('.'));
    let dateFormat = 'MMM d, yyyy';
    if (order === 'ymd') dateFormat = 'yyyy-MM-dd';
    else if (order === 'dmy') dateFormat = dot ? 'dd.MM.yyyy' : 'dd/MM/yyyy';
    return { dateFormat, timeFormat: hourCycle === 'h11' || hourCycle === 'h12' ? '12h' : '24h' };
  } catch {
    return null;
  }
};
